import { RootState } from 'reduxStore/store';

const getIsOpen = (state: RootState) => state.modal.isOpen;
const getContent = (state: RootState) => state.modal.content;
const getModalProps = (state: RootState) => state.modal.modalProps;

export { getIsOpen, getContent, getModalProps };
